import dayjs from "dayjs"
import DOMPurify from "dompurify"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router"

import { Button } from "components/Button"
import { Buttons } from "components/Card/Card"
import { GenericModal } from "components/Modal/Modal"
import Spacer from "components/Spacer"
import { SecurityToInsertReferent } from "containers/InsertCarer/InsertProfessionalCarer"
import { cdn } from "core/cdn"
import { ADMIN_CARERS_PAGE, READERS_CONFIGURATION_PAGE, STATISTICS_PAGE, SURVEY_PAGE } from "core/constants"
import { languages } from "lib/languages"
import { ClientStore } from "types/store"
import PreviousButton from "components/Previous/PreviousButton"

import styles from "./Home.module.scss"
import useUpdator from "./hooks/useUpdator"

const Home: React.FC<unknown> = ({ }) => {
  // Update REACT_APP
  const { version, needToUpdate } = useUpdator()
  const [displayedVersion, setDisplayedVersion] = useState<string | null>(null)
  if (needToUpdate) window.location.reload()
  ///////////////////////////////////////////
  const [modalPharmaAccountVisible, setModalPharmaAccountVisible] =
    useState(false)
  const [securedNavigationFor, setSecuredNavigationFor] = useState(null)

  const [showAccessibility, setShowAccessibility] = useState(false);

  const navigate = useNavigate()

  const { admin } = useSelector(({ client }: { client: ClientStore }) => ({
    admin: client.admin,
  }))

  useEffect(() => {
    if (version) {
      const datify = dayjs(version)
      if (datify.isValid()) setDisplayedVersion(datify.format("DD.MM.YYYY"))
      else setDisplayedVersion(version)
    }
  }, [version])

  return (
    <>
      {admin && (
        <div
          className={styles.PharmaAccount}
          onClick={() => {
            setModalPharmaAccountVisible(true)
          }}
        >
          <img
            src={cdn("/icons/profil_pharma.svg")}
            height={30}
            alt={languages.yourPharmaAccount}
          />
          <span className={styles.ConnectedAs}>{admin?.name}</span>
        </div>
      )}
      <div className={styles.LayoutHome} onClick={() => navigate(SURVEY_PAGE)}>
        <div className={styles.TaglineInfo}>
          <p className={styles.TaglineText}>{languages.tagline}</p>
        </div>
        <p className={styles.TouchScreen}>{languages.touch_screen}</p>
      </div>
      <img
        className={styles.HomepageImage}
        src={cdn("/images/homepage.png")}
        alt="Docteur en pharmacie"
      />
      <div className={styles.AccessibilityLink}><u><a onClick={() => setShowAccessibility(true)}>{languages.accessibility_declaration}</a></u></div>
      {displayedVersion && (
        <div className={styles.Versioning}>V. {displayedVersion}</div>
      )}
      <GenericModal
        title={
          securedNavigationFor ? null : languages.modal_pharmaAccount_title
        }
        noFooter
        closable
        onClose={() => setModalPharmaAccountVisible(false)}
        visible={modalPharmaAccountVisible}
      >
        {securedNavigationFor ? (
          <SecurityToInsertReferent
            onFinish={() => {
              navigate(securedNavigationFor)
            }}
            onCancel={() => setSecuredNavigationFor(null)}
          />
        ) : (
          <Spacer direction="vertical">
            <Buttons size={40}>
              <Button
                onClick={() => {
                  navigate(STATISTICS_PAGE)
                }}
              >
                {languages.myStatistics}
              </Button>
              <Button
                onClick={() => {
                  setSecuredNavigationFor(ADMIN_CARERS_PAGE)
                }}
              >
                ACCOMPAGNANTS
              </Button>
              <Button
                onClick={() => {
                  setSecuredNavigationFor(READERS_CONFIGURATION_PAGE)
                }}
              >
                {languages.associateKiosk.toUpperCase()}
              </Button>
            </Buttons>
            <div
              className={styles.Contact}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  languages.modal_pharmaAccount_information,
                  { USE_PROFILES: { html: true } }
                ),
              }}
            ></div>
          </Spacer>
        )}
      </GenericModal>
      {showAccessibility &&
        <GenericModal visible={showAccessibility} footer={undefined} bodyStyle={{ height: 600 }}>
          <div>
            <div style={{ textAlign: "right" }} onClick={() => setShowAccessibility(false)}>
              <PreviousButton
                text={languages.previous}
                onClick={() => setShowAccessibility(false)}
              />          </div>
            <div style={{ marginTop: "50px" }}>
              <iframe src={`https://info.medadom.com/declaration-accessibilite-kiosk`} width="1700px" height="600px" />
            </div>
          </div>
        </GenericModal>
      }
    </>
  )
}

export default Home
